module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "boxnote1"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "part1"
    }
  }), _c('span', {
    staticClass: "underline"
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" I")]), _c('br'), _vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECOND")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DITION")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_c('em', [_vm._v("Selling"), _c('br'), _vm._v("With"), _c('br'), _vm._v("Intention")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ab456b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 81
// module chunks = 0